import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "es-modal-header w-full" }
const _hoisted_2 = {
  key: 0,
  class: "col"
}
const _hoisted_3 = { class: "es-modal-header-txt" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  key: 1,
  class: "row-top w-full"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import EsConfirmDialog from '@/components/modals/esConfirmDialog.vue';
import { ItemButtonGroup } from "@/models/share.model";


export default /*@__PURE__*/_defineComponent({
  __name: 'esModalHeader',
  props: {
    displayDelete: { type: Boolean },
    displayConfirmDeleteModale: { type: Boolean },
    header: {},
    labelButtonAction: {},
    labelDelete: {},
    confirmMethod: { type: Function },
    iconAction: {},
    pathIconAction: {}
  },
  emits: ['execute-action'],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const props = __props;

const emits = __emit;
const isDeleteModalOpen = ref<boolean>(false);
const getIconContentButton = computed ((): ItemButtonGroup => ({
    codeAction: 'es-button-icon-danger',
    icon: 'trash',
    pathIcon: 'settings',
    method: undefined,
  })
);

const getIconActionButton = computed ((): ItemButtonGroup => {
  if (props.iconAction) {
    return {
      codeAction: 'es-button-icon-action',
      icon: props.iconAction,
      pathIcon: props.pathIconAction,
     method: undefined,
    };
  }
  return null;
});

const closeDeleteConfirmModal = async () => {
    if(props.confirmMethod){
        try {
          await props.confirmMethod();
          isDeleteModalOpen.value = false;
        } catch {
          throw t('error.DEFAULT');
        }
    }
}

const openDeleteModal = () => {
  if (!props.displayConfirmDeleteModale) {
    closeDeleteConfirmModal();
  } else {
    isDeleteModalOpen.value = true;
  }
}


return (_ctx: any,_cache: any) => {
  const _component_es_button = _resolveComponent("es-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.displayDelete && _ctx.labelButtonAction)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.header), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_es_button, {
                "icon-content-button": getIconActionButton.value,
                widthClass: 'w-full',
                class: "es-modal-header-shadow-button row",
                label: _unref(t)(_ctx.labelButtonAction),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('execute-action'))),
                "is-primary": false,
                "icon-styles": "img-primary"
              }, null, 8, ["icon-content-button", "label"]),
              _createVNode(_component_es_button, {
                "icon-content-button": getIconContentButton.value,
                class: "es-modal-header-shadow-button",
                label: _ctx.labelDelete,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (openDeleteModal())),
                "is-primary": false,
                "is-danger": true,
                "icon-styles": "img-red"
              }, null, 8, ["icon-content-button", "label"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("h3", {
              class: _normalizeClass(["es-modal-header-txt col-2", {'mbottom-10': !_ctx.labelButtonAction && !_ctx.displayDelete}])
            }, _toDisplayString(_ctx.header), 3),
            (_ctx.displayDelete)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_es_button, {
                    "icon-content-button": getIconContentButton.value,
                    class: "es-modal-header-shadow-button",
                    label: _ctx.labelDelete,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (openDeleteModal())),
                    "is-primary": false,
                    "is-danger": true,
                    "icon-styles": "img-red"
                  }, null, 8, ["icon-content-button", "label"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.labelButtonAction)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_es_button, {
                    label: _unref(t)(_ctx.labelButtonAction),
                    class: "es-modal-header-shadow-button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('execute-action'))),
                    "is-primary": false
                  }, null, 8, ["label"])
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _createVNode(EsConfirmDialog, {
      isOpen: isDeleteModalOpen.value,
      header: _unref(t)('calendar.appointment.delete.modale.header'),
      message: _unref(t)('calendar.appointment.delete.modale.message'),
      "on-confirm": closeDeleteConfirmModal,
      onModalClose: _cache[4] || (_cache[4] = ($event: any) => (isDeleteModalOpen.value = false))
    }, null, 8, ["isOpen", "header", "message"])
  ], 64))
}
}

})